import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateAccountHeadquartersMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountHeadquartersInput;
}>;

export type UpdateAccountHeadquartersMutationResult = { __typename?: 'Mutation' } & {
  updateAccountHeadquarters?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountHeadquartersPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountHeadquartersDocument = /*#__PURE__*/ gql`
  mutation updateAccountHeadquarters($input: UpdateAccountHeadquartersInput!) {
    updateAccountHeadquarters(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateAccountHeadquartersMutation__
 *
 * To run a mutation, you first call `useUpdateAccountHeadquartersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountHeadquartersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountHeadquartersMutation, { data, loading, error }] = useUpdateAccountHeadquartersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountHeadquartersMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAccountHeadquartersMutationResult, UpdateAccountHeadquartersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateAccountHeadquartersMutationResult, UpdateAccountHeadquartersMutationVariables>(
    UpdateAccountHeadquartersDocument,
    options
  );
}
export type UpdateAccountHeadquartersMutationHookResult = ReturnType<typeof useUpdateAccountHeadquartersMutation>;
